export default {
  // Page title
  'page.title': '秒表',
  
  // How to use
  'howto.title': '使用方法',
  'howto.step1': '点击"开始"按钮启动秒表，显示格式：分钟:秒钟.百分之一秒',
  'howto.step2': '秒表运行时点击"暂停"可暂停计时，再次点击"开始"继续计时',
  'howto.step3': '点击"重置"按钮将秒表重置为零并停止计时',
  'howto.step4': '秒表支持毫秒精度显示，适用于需要精确计时的场景',
  
  // User reviews
  'reviews.title': '用户评价',
  'reviews.michaelRunner': '训练必备神器！毫秒精度让我能准确记录每次冲刺成绩，操作简单快捷。',
  'reviews.chefJohnson': '烹饪计时神器！爆炒、煮面、蒸蛋都需要精确计时，这个秒表帮我做出完美菜品。',
  'reviews.sarahStudent': '考试模拟必备！用来练习答题时间，界面简洁不会分散注意力，提高了答题效率。',
  'reviews.coachWilliams': '训练课程的好助手！间歇训练和平板支撑都需要精确计时，学员们都很喜欢。',
  'reviews.drAnderson': '医疗工作经常需要精确计时，这个秒表简单可靠，是我临床工作的好助手。',
  
  // User names
  'user.michaelRunner': '跑步爱好者',
  'user.chefJohnson': '厨师老王',
  'user.sarahStudent': '学生小陈',
  'user.coachWilliams': '健身教练',
  'user.drAnderson': '医生李大夫',
  
  // Keywords section
  'keywords.stopwatch': '秒表 计时器 精确计时 现在几点',
  'keywords.english': 'stopwatch timer precision timing what time is it now',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};